import { Injectable } from '@angular/core';
import { LookupModel } from '../../common/models/LookupModel';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ModelResponse } from '../../core/services/ModelRequest';
import { DataSetRootEntityModel } from '../models/DataSetRootEntityModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ListMetadataModel } from '../models/ListMetadataModel';
import { DataWarehouseWorkspaceModelResponse } from '../models/DataWarehouseWorkspaceModelResponse';
import { SaveResultsModel } from '../models/SaveResultsModel';
import { NextgateSyncModel } from '../models/NextgateSyncModel';

@Injectable()
export class DataWarehouseService {
  public currentSubmittingEntityKey: string;

  constructor(private httpClient: HttpClient) {

  }

  getDataSets(): Observable<LookupModel[]> {
    return this.httpClient.get <ModelResponse<LookupModel[]>>("/api/DataWarehouseModule/DataSet/List").map(res => {
      var results = res.model;
      return results;
    });
  }

  getDataSetEntities(dataSet: LookupModel): Observable<LookupModel[]> {
    return this.httpClient.post<ModelResponse<LookupModel[]>>("/api/DataWarehouseModule/DataSet/Entity/List", dataSet)
      .map(res => {
        var results = res.model;
        return results;
      });
  }

  getDataSetEntityProperties(entity: LookupModel): Observable<LookupModel[]> {
    return this.httpClient.post<ModelResponse<LookupModel[]>>("/api/DataWarehouseModule/DataSet/Entity/Property/List", entity)
      .map(res => {
        var results = res.model;
        return results;
      });
  }

  getDataSetRootEntities(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<DataSetRootEntityModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<DataSetRootEntityModel>>("/api/DataWarehouseModule/DataSet/RootEntityList", { params: params });
  }

  getSubmittingEntityAllowedRootEntities(submittingEntityKey: string): Observable<ModelResponse<DataSetRootEntityModel[]>> {
        return this.httpClient.get<ModelResponse<DataSetRootEntityModel[]>>(`/api/DataWarehouseModule/Warehouse/${submittingEntityKey}/AllowedRootEntityList`);
  }

  getWarehouseList(entityKey: string,
    parentEntityKey: string,
    parentKey: string,
    page: number,
    pageSize: number,
    sort: string,
    sortDirection: string,
    searchTerm: string,
    submittingEntityKey: string,
    showDeleted: boolean): Observable<QueryResponse<any>> {
    let params = new HttpParams()
      .set("entityKey", entityKey)
      .set("showEntityDeleted", showDeleted ? showDeleted.toString() : "false")
      .set("skip", (page * pageSize).toString())
      .set("take", pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    if (parentEntityKey) {
      params = params.set('parentEntityKey', parentEntityKey);
    }
    if (parentKey) {
      params = params.set('parentKey', parentKey);
    }
    return this.httpClient.get<QueryResponse<any>>(`/api/DataWarehouseModule/Warehouse/${submittingEntityKey}/ListQuery`, { params: params });
  }

  getWarehouseListMetadata(entityKey: string): Observable<ModelResponse<ListMetadataModel>> {
    var params = new HttpParams()
      .set('entityKey', entityKey);
    return this.httpClient.get<ModelResponse<ListMetadataModel>>("/api/DataWarehouseModule/Warehouse/ListMetadata", { params: params });
  }

  getWarehouseWorkspace(entityKey: string, key: string, submittingEntityKey: string): Observable<DataWarehouseWorkspaceModelResponse> {
    return this.httpClient.get<DataWarehouseWorkspaceModelResponse>(`/api/DataWarehouseModule/Warehouse/${submittingEntityKey}/Workspace/${entityKey}/${key}`);
  }

  reviseRootEntity(entityKey: string, key: string, model: any, submittingEntityKey: string): Observable<ModelResponse<SaveResultsModel>> {
    return this.httpClient.post<ModelResponse<SaveResultsModel>>(`/api/DataWarehouseModule/Warehouse/${submittingEntityKey}/Workspace/${entityKey}/${key}/Revise/DataEntry`, model);
  }

  syncWithNextgate(key: string, isNew: boolean, currentAction: string): Observable<ModelResponse<NextgateSyncModel>> {
    return this.httpClient.get<ModelResponse<NextgateSyncModel>>(`/api/DataWarehouseModule/Warehouse/Workspace/${key}/${isNew}/${currentAction}/SyncWithNextgate`);
  }

  addWarehouseWorkspace(entityKey: string,
    parentEntityKey: string,
    parentKey: string,
    submittingEntityKey: string): Observable<DataWarehouseWorkspaceModelResponse> {
      var params = new HttpParams();
      if (parentEntityKey) {
        params = params.set('parentEntityKey', parentEntityKey);
      } else {
        params = params.set('parentEntityKey', '');
      }
      if (parentKey) {
        params = params.set('parentKey', parentKey);
      }
    return this.httpClient.get<DataWarehouseWorkspaceModelResponse>(`/api/DataWarehouseModule/Warehouse/${submittingEntityKey}/AddWorkspace/${entityKey}/`, { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/service/DataWarehouseService.ts